import React from 'react';
import { LoaderBall, StyledLoader } from './styles';

interface LoaderProps {
  inline?: boolean;
}

const Loader: React.FC<LoaderProps> = ({ inline = false }) => {
  return (
    <StyledLoader inline={inline}>
      <LoaderBall />
      <LoaderBall n={1} />
      <LoaderBall n={2} />
    </StyledLoader>
  );
};

export default Loader;
